import { axiosInstance } from "../../../axios/axiosInstance";

const API_FAQS_URL = "admin/faqs";
const API_FAQS_MODULE_LIST_URL = API_FAQS_URL + "/list";
const API_CREATE_FAQS_MODULE_URL = API_FAQS_URL + "/create";
const API_GET_FAQ_MODULE_BY_ID_URL = API_FAQS_URL + "/view";
const API_UPDATE_FAQ_MODULE_URL = API_FAQS_URL + "/update";
const API_DELETE_FAQ_MODULE_URL = API_FAQS_URL + "/update-status";


export const getFaqs = (dataToBeSent) => {
  return axiosInstance.get(`${API_FAQS_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}`);
};

export const createFaq = (dataToBeSent) => {
  return axiosInstance.post(API_CREATE_FAQS_MODULE_URL, dataToBeSent);
};


export const getFaqById = (dataToBeSent) => {
  return axiosInstance.get(API_GET_FAQ_MODULE_BY_ID_URL + "/" + dataToBeSent?.selectedFaqId);
};

export const updateFaq = (dataToBeSent) => {
  return axiosInstance.post(API_UPDATE_FAQ_MODULE_URL+ "/" + dataToBeSent?._id, dataToBeSent);
};

export const deleteFaqById = (dataToBeSent) => {
  return axiosInstance.patch(API_DELETE_FAQ_MODULE_URL + "/" + dataToBeSent?.selectedFaqId,{
    is_active : false
  });
};